import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Q from "clsx";
import e, { useEffect as x, useRef as X, useState as t } from "react";
import { useGlobalNavigation as Y } from "../../hooks/useGlobalNavigation";
import { AuthChecker as Z } from "./AuthChecker";
import { Branding as R } from "./Branding";
import { DesktopMenuTrigger as ee } from "./DesktopMenuTrigger";
import { Menu as te } from "./Menu";
import { MenuBackButton as re } from "./MenuBackButton";
import { MenuTrigger as ne } from "./MenuTrigger";
import { NavBlurBackground as oe } from "./NavBlurBackground";
import { NavPlaceholder as ie } from "./NavPlaceholder";
import { PrimaryNavContext as ae } from "./PrimaryNavContext";
import { UserActionsTrigger as se } from "./UserActionsTrigger";
import { useBreakpoint as le } from "./hooks/useBreakpoint";
import { useFlyoutAnimation as me } from "./hooks/useFlyoutAnimation";
import { useFlyoutHeight as ue } from "./hooks/useFlyoutHeight";
import { useScrollbarWidth as pe } from "./hooks/useScrollbarWidth";
import { useTouch as ce } from "./hooks/useTouch";
import { useViewportInfo as fe } from "./hooks/useViewportInfo";
import { isValidUser as I } from "./helpers/user";

var T = function T(s) {
  return s > 0 ? Math.min(480, Math.max(240, s / 2)) : 0;
},
    He = function He(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      s = _ref$ariaLabel === void 0 ? "Global Navigation" : _ref$ariaLabel,
      S = _ref.className,
      p = _ref.dataApi,
      U = _ref.logo,
      v = _ref.mw,
      w = _ref.style,
      _ref$testId = _ref.testId,
      D = _ref$testId === void 0 ? "hg-primarynav" : _ref$testId,
      O = _ref.theme,
      l = _ref.user,
      y = _ref.wordmark,
      E = _ref.loginAction,
      H = _ref.logoutAction,
      c = _ref.authCheckFn,
      B = _ref.activeIndex;

  var _t = t(null),
      _t2 = _slicedToArray(_t, 2),
      n = _t2[0],
      F = _t2[1],
      _t3 = t(!1),
      _t4 = _slicedToArray(_t3, 2),
      L = _t4[0],
      C = _t4[1],
      _t5 = t(null),
      _t6 = _slicedToArray(_t5, 2),
      f = _t6[0],
      _ = _t6[1],
      _t7 = t(!1),
      _t8 = _slicedToArray(_t7, 2),
      g = _t8[0],
      o = _t8[1],
      _t9 = t(!1),
      _t10 = _slicedToArray(_t9, 2),
      d = _t10[0],
      h = _t10[1],
      _t11 = t(!1),
      _t12 = _slicedToArray(_t11, 2),
      M = _t12[0],
      W = _t12[1],
      _t13 = t(!1),
      _t14 = _slicedToArray(_t13, 2),
      $ = _t14[0],
      A = _t14[1],
      _t15 = t(!0),
      _t16 = _slicedToArray(_t15, 2),
      G = _t16[0],
      P = _t16[1],
      _t17 = t(null),
      _t18 = _slicedToArray(_t17, 2),
      N = _t18[0],
      i = _t18[1],
      b = X(null),
      V = fe(),
      j = pe(),
      a = ue(n),
      r = le(V, ["xsmall", "small", "medium"]),
      q = ce(),
      k = me(n),
      z = Y(p),
      J = function J() {
    _(a), o(!0), h(!0);
    var m = T(a);
    setTimeout(function () {
      o(!1);
    }, m);
  },
      K = function K() {
    o(!0), h(!1);
    var m = T(a);
    setTimeout(function () {
      o(!1);
    }, m);
  };

  return x(function () {
    C(n !== null && r), A(!1);
  }, [n, r]), x(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var u;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              P(!0);
              _context.prev = 1;

              if (!(l && I(l))) {
                _context.next = 6;
                break;
              }

              i(l);
              _context.next = 14;
              break;

            case 6:
              if (!c) {
                _context.next = 13;
                break;
              }

              _context.next = 9;
              return c();

            case 9:
              u = _context.sent;
              I(u) ? i(u) : i(null);
              _context.next = 14;
              break;

            case 13:
              i(null);

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error("Error checking authentication: ", _context.t0), i(null);

            case 19:
              _context.prev = 19;
              P(!1);
              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16, 19, 22]]);
    }))();
  }, [c, l]), e.createElement(ae.Provider, {
    value: {
      activeFlyout: n,
      setActiveFlyout: F,
      isBreakpointWithMenu: r,
      isTouch: q,
      scrollbarWidth: j,
      flyoutAnimation: k,
      menuData: z,
      isAnimating: g,
      setIsAnimating: o,
      isSubmenuOpen: d,
      setIsSubmenuOpen: h,
      isDesktopMenuOpen: M,
      setIsDesktopMenuOpen: W,
      isUserActionsMenuOpen: $,
      setIsUserActionsMenuOpen: A,
      authenticatedUser: N,
      isAuthLoading: G,
      handleFlyoutOpen: J,
      handleFlyoutClose: K,
      loginAction: E,
      logoutAction: H
    }
  }, e.createElement("nav", {
    ref: b,
    className: Q("hg-primarynav", k, {
      "hg-primarynav--animating": g,
      "hg-primarynav--with-submenu-open": d,
      "hg-primarynav--with-menu-open": L,
      "hg-primarynav--with-desktop-menu-open": M
    }, S),
    "aria-label": s,
    "data-theme": O,
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, a !== null && f !== null && {
      "--primarynav-next-flyout-height": r ? null : "".concat(a, "px")
    }), f !== null && {
      "--primarynav-previous-flyout-height": r ? null : "".concat(f, "px")
    }), v !== void 0 && {
      "--primarynav-max-width": "".concat(v, "px")
    }), w),
    "data-api": typeof p == "string" ? p : void 0,
    "data-testid": D
  }, e.createElement("div", {
    className: "hg-primarynav__content",
    style: {
      "--primarynav-flyout-rate": r ? "422ms" : null
    }
  }, e.createElement(re, {
    parentRef: b
  }), e.createElement("ul", {
    className: "hg-primarynav__list",
    id: "hg-primarynav__list"
  }, e.createElement(R, {
    name: "hagerty",
    url: "/",
    label: "Hagerty",
    wordmark: y,
    logo: U
  }), e.createElement(te, {
    activeIndex: B
  }), e.createElement(Z, null), e.createElement(ee, null)), N && e.createElement(se, {
    wordmark: y
  }), e.createElement(ne, null))), e.createElement(oe, null), e.createElement(ie, null));
};

export { He as PrimaryNav, T as calculateAnimationDuration };